module.exports = __webpack_public_path__ + "static/img/qrcode.e4bd0225.png";